/**
 * 注文変更拒否エラーの商品情報
 */
export type OrderErrorItem = {
  /**
   * オーダー番号
   */
  orderNum: string;
  /**
   * 親アイテムコード
   */
  oyaItemCode: string;
  /**
   * 子アイテムコード
   */
  itemCode: string;
  /**
   * エラーステータス
   */
  status: number;
  /**
   * エラーテキスト
   */
  statusText: string;
  /**
   * 商品名
   */
  name: string;
  /**
   * 商品価格
   */
  price: number;
  /**
   * 変更前の数量
   */
  quantity: number;
};

/**
 * 注文変更済みの商品情報
 */
export type OrderItem = {
  /**
   * オーダー番号
   */
  orderNum: string;
  /**
   * 親アイテムコード
   */
  oyaItemCode: string;
  /**
   * 子アイテムコード
   */
  itemCode: string;
  /**
   * 選択した個数、削除の時は0、戻す時は注文確定されている個数
   */
  afterQuantity: number;
  /**
   * 注文確定されている個数
   */
  fixedQuantity: number;
  /**
   * 購入可能上限個数
   */
  limitQuantity: number;
};

/**
 * 注文変更処理の結果
 */
export type CartChangeResult = {
  orderNum: string;
  changeItems: OrderItem[];
  errItems: OrderErrorItem[];
};

/**
 * レスポンスデータ
 */
export type ResponseData = {
  status: number;
  statusText: string;
  responseData: CartChangeResult;
};

/**
 * 処理モードのタイプ
 */
export enum CartOrderRequestType {
  /**
   * 数量変更
   */
  Change = "change",
  /**
   * 削除
   */
  Delete = "delete",
  /**
   * 戻す
   */
  Restore = "restore",
}

/**
 * リクエストデータ
 */
export type RequestData = {
  mode: CartOrderRequestType;
  orderNum: string;
  [key: string]: string;
};

/**
 * APIへ送信するリクエストボディの接頭キー
 */
export type RequestDataKeyPrefix = keyof RequestData;

/**
 * 買い物カゴAPI
 */
export type CartOrderApiFactory = {
  /**
   * 注文データの更新関数
   */
  updateCartOrderItems(data: RequestData): Promise<ResponseData>;
};
